<template>
    <div>
        <h4 class="subtitle is-6 mb-5">
            Below are some useful documents for you to access during your tenancy.
        </h4>

        <TenancyNotes classes="is-6-tablet is-3-desktop" />
    </div>
</template>

<script>
import TenancyNotes from '../components/TenancyNotes.vue';

export default {
    components: {
        TenancyNotes,
    },
};
</script>
